/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  window.carouselVideos = {};
  window.onYouTubePlayerAPIReady = function () {
    $( '.item-video' ).each(function(){
        var li = $(this);
        var iframeNode = li.find('.video-holder iframe').get(0);
        iframeNode.src += '&enablejsapi=1&api=1';
        iframeNode.setAttribute('id', 'video-iframe-'+li.index());
        
       if( iframeNode.src.toLowerCase().indexOf('youtube') !== -1 ) {
          window.carouselVideos[iframeNode.getAttribute('id')] = new YT.Player(iframeNode.getAttribute('id'));
        }
     });
  };

  var tag = document.createElement('script');
  tag.src = "//www.youtube.com/player_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
         

        // Toggle menu button and animation
        document.querySelector( ".btn-toggle" )
          .addEventListener( "click", function() {
            this.classList.toggle( "active" );
          });

        $( ".btn-toggle" ).click(function() {
          $( "#slidemenu" ).toggle();
          $( '#werkgruppen-menu').toggleClass('white');
        });
        $( ".btn-toggle" ).click(function() {
          $( "#headerblock" ).toggle({width: 'toggle'});
          $( ".roots-breadcrumb").toggle();
          $( "#werkgruppen-crumbs .inline").toggle();
        });

        // toggle tooltips for iphone/ipad
        $( "span.easy-tooltip" ).click(function() {
          $( "span.classic" ).toggle();
        });

        // toggle desc on featured imaǵe
        $( ".sliderinfo" ).click(function() {
          $( ".slidertxt" ).toggle();
          $( ".slidernav a" ).toggleClass( "txt-white", function() {
          });
          $( ".sliderclose" ).toggle();
        });
        $( ".sliderclose" ).click(function() {
          $( ".news" ).toggle();
          $( ".showNews" ).toggle();
          $( ".slidertxt" ).toggle();
          $( ".slidernav a" ).removeClass( "txt-white", function() {
          });
          $( ".sliderclose" ).toggle();
        });
        $( ".showNews" ).click(function() {
          $( ".news" ).toggle();
          $( ".showNews" ).toggle();
          $( ".sliderclose" ).toggle();
        });

        //$('#post-carousel li:first').addClass('active');
        $('#post-carousel').each( function( i, elem ){
            var url = $.trim( window.location.pathname );
            if( url.indexOf( '/' ) === 0 ){ 
              url = url.substring( 1 );
            }
            if( url.lastIndexOf( '/' )+1 === url.length  ){ 
              url = url.substring( 0, url.length - 1 ); 
            }

            var path = url.split( '/' )
            // http://wnm.cdlxs.de/de/artefakte/[sliderNumber]/
            var slide = parseInt( path[ 2 ] );

            $( elem ).data( 'url', window.location.origin + '/' + path[0] + '/' + path[1] + '/' );

            var liCount = $( elem ).find( '.carousel-inner > li' ).length;

            if( !isNaN( slide ) ){
              var liCount = $( elem ).find( '.carousel-inner > li' ).length;
              
              if( slide > liCount ){
                slide = liCount;
              }else if( slide < 1 ){
                slide = 1;
              }

            }else{
              slide = 1;
            }

            $( elem ).find( 'li:nth-child('+ slide +')' ).addClass('active');

            if( liCount <= 1 ){ 
              $('[href="#post-carousel"][data-slide]').hide();

            }


            // update history, pause video
            $( elem ).on('slide.bs.carousel', function ( e ) {
              var newIndex = $( e.relatedTarget ).index()+1;
              var url = $( elem ).data( 'url' ) + newIndex;

              //window.history.replaceState( null, $( 'html head title' ).text(), url );
              window.history.replaceState( null, 'title', url );

              $( elem ).find( '.item-video .video-holder iframe' ).each(function(){
                var iframeNode = $(this).get(0);
                var player = window.carouselVideos[iframeNode.getAttribute('id')];

                if( iframeNode.src.toLowerCase().indexOf('vimeo') !== -1 ) {
                  player.api("pause");
                } else if( iframeNode.src.toLowerCase().indexOf('youtube') !== -1 ) {
                  try {
                    player.pauseVideo();
                  } catch(e) { };
                }
              });

              ga('send', {
                'hitType': 'pageview',
                'location': url
              });
            });
            

            //play video
            $( elem ).find( '.item-video .play-video' ).on( 'click', function ( e ) {
              var btn = $(this);
              var li = btn.parent();
              var videoHolder = li.find('.item-img > .fve-max-width-wrapper, .video-holder');
              var iframeNode = videoHolder.find('iframe').get(0);
              var player = window.carouselVideos[iframeNode.getAttribute('id')];

              btn.hide();

              if( iframeNode.src.toLowerCase().indexOf('vimeo') !== -1 ) {
                player.api('play');
              } else if( iframeNode.src.toLowerCase().indexOf('youtube') !== -1 ) {
                try{
                  player.playVideo();
                } catch(e) { };
              }

              li.addClass('video-is-playing');
              videoHolder.show();
             });
              
              
              //enable player api
             $( elem ).find( '.item-video' ).each(function(){
                var li = $(this);
                var iframeNode = li.find('.video-holder iframe').get(0);
                var player;
                iframeNode.src += '&enablejsapi=1&api=1';
                iframeNode.setAttribute('id', 'video-iframe-'+li.index());
                
                if( iframeNode.src.toLowerCase().indexOf('vimeo') !== -1 ) {
                  window.carouselVideos[iframeNode.getAttribute('id')] = $f(iframeNode);
                }/* else if( iframeNode.src.toLowerCase().indexOf('youtube') !== -1 ) {
                  player = new YT.Player(iframeNode.getAttribute('id'));
                }*/
             });

              
        } );


        $('.tab-content li:first').addClass('active');

      // zoom functions on frontpage
      $('.frontimg').click(function(){
        $('.tiles').toggle();
      });
      $('.tile').click(function(){
        $('.tiles').toggle();
      });

      $('.tile')
        // tile mouse actions
        .on('hover', function(){
          $(this).children('.photo').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
        })
        .on('mousemove', function(e){
          $(this).children('.photo').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
        })
        // tiles set up
        .each(function(){
          $(this)
            // add a photo container
            .append('<div class="photo" id="zoomz-move"></div>')
            .children('.photo').css({'background-image': 'url('+ $(this).attr('data-image') +')'});
      });

      $(document).keydown(function(e) {
        if (e.keyCode === 27) {
          $('.tiles').toggle();
        }
        // add keyboard codes for carousel
        if(e.keyCode==39){
          $('[href="#post-carousel"][data-slide="next"]:not(.carousel-control):visible').trigger('click');
          //$('a.carousel-control.right').trigger('click');
        }   
        else if(e.keyCode==37){
          $('[href="#post-carousel"][data-slide="prev"]:not(.carousel-control):visible').trigger('click');
          //$('a.carousel-control.left').trigger('click');
        }
      });
      /* disabled breadcrump...
        $('li.back').click(function(){
          //TODO sr
          alert( 'najaa' )
          parent.history.back();
          return false;
        });
*/

      /*
      //add touch support
      var redBox = document.getElementById('touch'),
      greenBox = document.getElementById('zoomz-move'),
      state = null;

      addEventListeners([redBox, greenBox], "mousemove touchmove click", function(e){
        e.preventDefault();
        console.log('move!');
        var x = e.touches ? e.touches[0].pageX : e.offsetX,
            y = e.touches ? e.touches[0].pageY : e.offsetY;

        if(state=='down'){
          jQuery('#zoomz-move').css({'transform-origin': ((x - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((y - $(this).offset().top) / $(this).height()) * 100 +'%'});
          console.log('drag');
        }
      }, false);


      addEventListeners([redBox, greenBox], "mouseup touchend", function(e){
        e.preventDefault();
        state = 'up';
        console.log('up');
        lastPos = getLastPosition();
        posX = parseInt(lastPos[0]);
        posY = parseInt(lastPos[1]);
        console.log('touchendX: '+posX);
        console.log('touchendY: '+posY);

      }, false);


      var tapped=false;
      var zoomed=false;
      $("#zoomz-move").on("touchstart",function(e){
        e.preventDefault();
        state = 'down';
        if(!tapped){ //if tap is not set, set up single tap
          tapped=setTimeout(function(){
            tapped=null;
            console.log('singletap');
          },300);   //wait 300ms then run single click code
        } else {    //tapped within 300ms of last tap. double tap
          clearTimeout(tapped); //stop single tap callback
          tapped=null;
          console.log('doubletap');
          console.log(zoomed);
          if(zoomed){
            jQuery('#zoomz-move').css({'transform': 'scale('+ 1 +')'});
            zoomed = false;
          } else {
            jQuery('#zoomz-move').css({'transform': 'scale('+ 1 +')'});
            zoomed = true;
          }
        }
        e.preventDefault();
      });
    
    */

    //$.waitForImages.hasImgProperties = [ 'backgroundImage' ];
    $('.imgLoading').each( function( i, elem ){
      var $img = $(this);
      $img.after( '<div class="imgLoading-loading"></div>' );
      $img.waitForImages( null, function(){
        $img.parent().find( '.imgLoading-loading' ).remove();
      }, true );
    });




  },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Werkgruppen
    'werkgruppen': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Werkgruppen
    'biografie': {
      init: function() {
      },
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'post': {
      init: function() {
        // Fire the slider
        $(document).ready(function() {
          $('#post-carousel').carousel({
            pause: 'none'
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each( document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.